<!-- <app-menu-common url="sales" *ngIf="!dialogData"></app-menu-common> -->
<app-menu-common url="logistic"></app-menu-common>

<!-- <mat-card class="calendar-card">
    <mat-calendar [(selected)]="dateSelected"></mat-calendar>
  </mat-card> -->
  <!-- <p>Selected date: {{dateSelected()}}</p> -->
  <!-- <p>orders : {{orders | json}}</p> -->
  <div class="planning">

  @for (order of orders; track order.id) {
    <!-- for dev car une commande qui doit être livré doit avoir un client -->
    <!-- @if (order.lnk_customer && order.lnk_customer.id  && order.id <91   ) {  -->
      <!-- @if (order.lnk_customer && order.lnk_customer.id  && order.lnk_delivery   ) {  -->
        @if (order.lnk_customer && order.lnk_customer.id   ) { 
        <app-card-livraison [order]="order"   ></app-card-livraison>
    }
    <!-- <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
    </mat-card> -->
  }
  </div>
<!-- 
<div class=" planning_card">
    
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>
      <mat-card class="delivery-card" appearance="outlined">
        <mat-card-content>Simple card</mat-card-content>
      </mat-card>

</div>
 -->


